import './TagsView.scss';

export { default } from './TagsView';
